export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9193.3bda7f4c.jpg";